
// 从环境变量获取基础域名，如果没有则使用默认值
export const getBaseDomain = (): string => {
  // 在开发环境中使用配置的域名，生产环境中使用当前域名
  const isDev = import.meta.env.DEV;
  return isDev && import.meta.env.VITE_AUTH_DOMAIN
    ? import.meta.env.VITE_AUTH_DOMAIN
    : window.location.origin;
};



